/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

export type ReportsFindAllSurveillanceTypeItem =
  (typeof ReportsFindAllSurveillanceTypeItem)[keyof typeof ReportsFindAllSurveillanceTypeItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindAllSurveillanceTypeItem = {
  active: 'active',
  passive: 'passive',
  other: 'other',
} as const;
